import React, { Component, SyntheticEvent } from 'react';
import './filter-popup.css';
import {
  Accordion,
  AccordionPanelProps,
  Button,
  Checkbox,
  Dropdown,
  DropdownItemProps,
  DropdownProps,
  Form,
  Icon,
  Menu,
  Popup,
  Label, Loader
} from 'semantic-ui-react';
import { CONFIG } from '../../../helper/config';
import {
  FilterInfo,
  FilterData,
  GroupByColumnOption,
} from '../../../modal/filters';
import { getMultipleDropdownOptions, setColumnFilterData, setSearchFilterData, updateFiltersObj } from '../../../actions/card-library.actions';
import { connect } from 'react-redux';
import _ from 'lodash';
import { DAG } from '../../../helper/dag';
import LoaderComponent from '../../loader/loader';

interface IProps {
  filter_data: FilterData;
  appliedTimePeriodFilters: any;
  template_config: any;
  token: any;
  column_filter_data: any;
  search_filter_data: any;
  submitFilters: (filter_columns: FilterInfo[], timePeriodFilters: any) => void;
  getMultipleDropdownOptions: (arg0: any, arg1: any, arg2: any) => void;
  setColumnFilterData: (arg0: any) => void;
  setSearchFilterData: (arg0: any) => void;
  updateFiltersObj: (arg0: any) => void;
  search_filter_obj: any;
  team_context: any;
  va_id: any;
}

interface IState {
  filter_columns: FilterInfo[];
  filter_data: FilterData;
  is_update_filter: boolean;
  is_submit_filter: boolean;
  parent_mapping_graph: DAG;
  show_filter_label_tooltip: string;
  active_year: any;
  active_quarter: any;
  active_month: any;
  active_week: any;
  active_day_of_year: any;
  heaing_2_bind_col_name: string;
  selectedTimePeriodFilters: any;
  filtered_values: any;
  selected_filtered: any;
  filter_obj: any;
  time_period_obj: Object;
  column_filter_values: any;
  active_col_id: any;
  base_filter: any;
  search_value: string;
}

const TIME_PERIOD_PANEL = {
  year: 'quarter',
  quarter: 'month',
  month: 'week',
  week: 'date',
  date: 'day_of_year'
};

export class FilterPopup extends Component<IProps, IState> {
  timer: any = React.createRef();
  /**
   * Constructor to initialize the component state.
   * @param {IProps} props - The props object passed to the component.
   */
  constructor(props: IProps) {
    super(props);
    const { heading_2, type } = this.props.template_config;
    const separator = type === "POWERBI" ? "/beagle-table-sep-/" : ".";
    let heading2BindColName = "";
    if (heading_2?.bind_col_name) {
      if (heading_2.bind_col_name.includes(separator)) {
        heading2BindColName = heading_2.bind_col_name.split(separator)[1];
      } else {
        heading2BindColName = heading_2.bind_col_name;
      }
    }
    this.state = {
      filter_columns: props.filter_data.filter_columns
        ? JSON.parse(JSON.stringify(props.filter_data.filter_columns))
        : [],
      filter_data: props.filter_data
        ? JSON.parse(JSON.stringify(props.filter_data))
        : {},
      is_update_filter: false,
      heaing_2_bind_col_name: heading2BindColName,
      is_submit_filter: false,
      parent_mapping_graph: this.parentMappingGraph(),
      show_filter_label_tooltip: '',
      active_year: -1,
      active_quarter: -1,
      active_month: -1,
      active_week: -1,
      active_day_of_year: -1,
      selectedTimePeriodFilters: [],
      filtered_values: [],
      selected_filtered: [],
      filter_obj: {},
      time_period_obj: {},
      column_filter_values: {},
      active_col_id: -1,
      base_filter: this.props.template_config.filter,
      search_value: "",
    };
  }

   /**
   * Builds a parent mapping graph (DAG) from the filter data's parent mapping.
   * This graph is used to determine dependent filters for cascading filtering.
   *
   * @returns {DAG} A directed acyclic graph representing parent-child filter relationships.
   */
  parentMappingGraph = () => {
    let { filter_data } = this.props;
    let parent_mapping_graph;
    if (filter_data?.parent_mapping) {
      let no_of_vertex = Object.keys(filter_data.parent_mapping).length;
      parent_mapping_graph = new DAG(no_of_vertex);
      Object.entries(filter_data.parent_mapping).forEach(([key, value], j) => {
        parent_mapping_graph.addEdge(Number(key), value);
      });
    } else {
      parent_mapping_graph = new DAG(0);
    }
    return parent_mapping_graph;
  };

  /**
   * Handles updating the state when the component's props change.
   * @param prevProps The previous props.
   * @param prevState The previous state.
   */
  componentDidUpdate(prevProps: IProps, prevState: IState) {
    let { filter_data, search_filter_data } = this.props;
    let { filter_obj, filter_columns, active_col_id } = this.state;

    if (Object.keys(filter_obj).length === 0 && filter_columns.length > 0) {
      const newFilterObj = {};

      for (const column of filter_columns) {
        newFilterObj[column.column_id] = Object.keys(column.applied_filter).length !== 0
          ? column.applied_filter['values']
          : [];
      }

      this.setState({ filter_obj: JSON.parse(JSON.stringify(newFilterObj)) });
    }

    if (
      !_.isEqual(filter_data.columns, prevProps.filter_data.columns) &&
      filter_data.columns
    ) {
      let parent_mapping_graph = this.parentMappingGraph();
      this.setState({
        parent_mapping_graph: parent_mapping_graph,
        filter_columns: JSON.parse(JSON.stringify(filter_data.filter_columns)),
        filter_data: JSON.parse(JSON.stringify(filter_data)),
      });
    }
    if (this.state.is_update_filter === false && prevState.filtered_values.length > 0) {
      this.setState({ filtered_values: prevState.filtered_values })
    }
    if (active_col_id === search_filter_data.column_id && !_.isEqual(prevProps.search_filter_data, search_filter_data)) {
      this.setState({ column_filter_values: search_filter_data })
    }
  }

  /**
   * Lifecycle method that executes after the component is mounted.
   * It initializes the time period filters and filter objects based on the
   * provided props and current state. If any applied time period filters exist,
   * they are set as the selected time period filters. If no applied filters
   * are provided, the component checks the filter data for time period filters
   * and sets them accordingly. Additionally, it initializes the filter object
   * if it is empty by mapping the filter columns and their applied filter values.
   */
  componentDidMount() {
    const { appliedTimePeriodFilters, filter_data, } = this.props;
    let { filter_obj, filter_columns, time_period_obj } = this.state;
    if (appliedTimePeriodFilters && appliedTimePeriodFilters.length > 0) {

      if (appliedTimePeriodFilters[0]['year'] && time_period_obj['year'] === undefined) {
        time_period_obj['year'] = 1
      }
      if (appliedTimePeriodFilters[0]['quarter'] && time_period_obj['quarter'] === undefined) {
        time_period_obj['quarter'] = 2
      }
      if (appliedTimePeriodFilters[0]['month'] && time_period_obj['month'] === undefined) {
        time_period_obj['month'] = 3
      }
      if (appliedTimePeriodFilters[0]['week'] && time_period_obj['week'] === undefined) {
        time_period_obj['week'] = 4
      }
      if (appliedTimePeriodFilters[0]['date'] && time_period_obj['date'] === undefined) {
        time_period_obj['date'] = 5
      }
      this.setState({ selectedTimePeriodFilters: appliedTimePeriodFilters });
    } else
      if (filter_data.time_period_filter_data && Object.keys(filter_data.time_period_filter_data).length > 0) {

        if (filter_data.time_period_filter_data.data[0]['year'] && time_period_obj['year'] === undefined) {
          time_period_obj['year'] = 1
        }
        if (filter_data.time_period_filter_data.data[0]['quarter'] && time_period_obj['quarter'] === undefined) {
          time_period_obj['quarter'] = 2
        }
        if (filter_data.time_period_filter_data.data[0]['month'] && time_period_obj['month'] === undefined) {
          time_period_obj['month'] = 3
        }
        if (filter_data.time_period_filter_data.data[0]['week'] && time_period_obj['week'] === undefined) {
          time_period_obj['week'] = 4
        }
        if (filter_data.time_period_filter_data.data[0]['date'] && time_period_obj['date'] === undefined) {
          time_period_obj['date'] = 5
        }
        this.setState({
          selectedTimePeriodFilters: filter_data.time_period_filter_data.data,
        });
      }

    if (filter_obj && typeof filter_obj === 'object' && Object.keys(filter_obj).length === 0 && Array.isArray(filter_columns) && filter_columns.length > 0) {

      const newFilterObj = {};

      for (const column of filter_columns) {
        newFilterObj[column.column_id] = column.applied_filter && typeof column.applied_filter === 'object' && Object.keys(column.applied_filter).length !== 0
          ? column.applied_filter['values'] : [];
      }

      this.setState({ filter_obj: newFilterObj });
    }

  }

  /**
   * Submits the applied filters.
   * Cleans up empty or redundant filters, validates group-by filters,
   * and calls the parent submit handler with filter columns and time period filters.
   */
  submitFilters = () => {
    let { is_submit_filter, filter_columns, selectedTimePeriodFilters } = this.state;
    let { search_filter_obj } = this.props;
    filter_columns.map((fc) => {
      if (fc.type !== "groupby_column") {
        if (typeof fc.applied_filter['values'] === "object") {
          fc.applied_filter['values'] = fc.applied_filter['values'].flat()
        }
        let data = search_filter_obj?.[fc.column_id] ? search_filter_obj[fc.column_id] : [];
        if (fc.applied_filter['values']?.length >= data?.length && data.length > 0 || fc.applied_filter['values']?.length === 0) {
          fc.applied_filter = {} as any;
        }
      }
    })
    if (!is_submit_filter) {
      this.setState({ is_submit_filter: true });
    }
    let is_group_by_column_filterd =
      filter_columns.findIndex(
        (fc) => fc.type === CONFIG.GROUPBYCOLUMN && !fc.applied_filter.column_id
      ) === -1;
    if (is_group_by_column_filterd) {
      this.setState({ is_update_filter: false, is_submit_filter: false });
      this.props.submitFilters(filter_columns, selectedTimePeriodFilters);
    }
  };

  /**
   * Clears a specific filter column and resets its applied filter state.
   *
   * @param current_filter_column The filter column to clear.
   */
  clearIndivisualFilter = (current_filter_column) => {
    let { filter_columns, is_update_filter, filter_obj } = this.state;
    filter_columns = filter_columns.map((column) => {
      if (column === current_filter_column) {
        column.applied_filter = {} as any;
        filter_obj[`${current_filter_column.column_id}`] = []
        this.setState({ filter_obj })
        this.props.updateFiltersObj({})
        return column;
      } else return column;
    });

    if (!is_update_filter) {
      is_update_filter = true;
    }

    this.setState({ filter_columns, is_update_filter });
    this.props.updateFiltersObj({})
  };

  /**
   * Clears all applied filters except group-by filters.
   * Resets filter state and updates the Redux store with empty filters.
   */
  clearFilters = () => {
    let { filter_columns, is_update_filter, filter_obj } = this.state;
    filter_columns = filter_columns.map((fi) => {
      if (fi.type !== 'groupby_column') {
        fi.applied_filter = {} as any;
        return fi;
      } else return fi;
    });
    for (let i in filter_obj) {
      filter_obj[i] = []
    }
    if (!is_update_filter) {
      is_update_filter = true;
    }
    this.props.updateFiltersObj({})
    this.setState({ filter_columns, is_update_filter, filtered_values: [], filter_obj });
  };

  /**
   * Handles filter dropdown value changes.
   * Updates the local state and applied filter object based on selection.
   *
   * @param event The dropdown change event.
   * @param data  Dropdown data containing name and selected value(s).
   */
  handleFilterDropdownChange = (event: SyntheticEvent, data: DropdownProps) => {
    event.preventDefault()
    let { name, value } = data;
    let { filter_obj } = this.state;
    if (typeof value === "object" && value.length > 0) {
      value = Array.from(new Set(value.concat(this.state.filter_obj[name])))
      filter_obj[`${name}`] = value;
      this.setState({ filter_obj: JSON.parse(JSON.stringify(filter_obj)) })

    }
    let { filter_columns, is_update_filter } = this.state;
    let { template_config } = this.props
    if (!is_update_filter) {
      is_update_filter = true;
    }
    let index = -1;
    if (isNaN(name)) {
      index = filter_columns.findIndex((f) => f.filter_name === name);
      const selected_option = filter_columns[index].options!.find(
        (option) => option.column_id === value
      );
      filter_columns[index].applied_filter = selected_option!;
    } else {
      index = filter_columns.findIndex((f) => f.column_id === name);

      if (index !== -1) {
        filter_columns[index].applied_filter = {
          column_id: filter_columns[index].column_id || -1,
          conjuction: '',
          table_id: filter_columns[index].table_id ? filter_columns[index].table_id : template_config.table_id,
          name: `${filter_columns[index].table_name}${template_config.type === "POWERBI" ? '/beagle-table-sep-/' : '.'}${filter_columns[index].filter_name}`,
          operator: CONFIG.FILTEROPERATOR.IN,
          values: [value === 'Null' ? null : value as any],
        };
      }
    }
    this.setState({ filter_columns, is_update_filter });
  };

  /**
   * Renders filter dropdowns in groups of 4.
   * If time period filters exist, appends a time period dropdown group.
   *
   * @returns {JSX.Element[]} An array of form groups containing dropdowns.
   */
  renderFilterDropdowns = () => {
    let { filter_columns } = this.state;
    const { filter_data } = this.props;
    let form_groups: JSX.Element[] = [];
    for (let index = 0; index < filter_columns.length; index += 4) {
      let end_index = index + 4;
      end_index =
        end_index > filter_columns.length ? filter_columns.length : end_index;
      let form_group: JSX.Element = (
        <Form.Group widths={4} key={`form-froup${index}`}>
          {this.returnDropdowns(index, end_index)}
        </Form.Group>
      );
      form_groups.push(form_group);
    }

    if ((filter_columns.length === 0 || filter_columns.length % 4 === 0) && filter_data.time_period_filter_data && Object.keys(filter_data.time_period_filter_data).length > 0) {
      let form_group: JSX.Element = (
        <Form.Group widths={4} key='time-period-group'>
          {this.returnTimePeriodDropdown()}
        </Form.Group>
      );
      form_groups.push(form_group);
    }
    return form_groups;
  };

  /**
   * Updates state for active time period levels (year, quarter, etc.)
   * and resets dependent levels when a selection changes.
   *
   * @param level The time period level being updated (e.g., "year", "month").
   * @param value The selected value for the level.
   */
  updateTimePeriodLevelState = (level, value) => {
    const LEVEL_STATES = {
      year: {
        active_quarter: -1,
        active_month: -1,
        active_week: -1,
        active_day_of_year: -1,
      },
      quarter: { active_month: -1, active_week: -1, active_day_of_year: -1 },
      month: { active_week: -1, active_day_of_year: -1 },
      week: { active_day_of_year: -1 },
      day: {},
    };

    if (this.state[`active_${level}`] === value) {
      this.setState({ [`active_${level}`]: '', ...LEVEL_STATES[level] } as Pick<
        any,
        keyof IState
      >);
    } else {
      this.setState({
        [`active_${level}`]: value,
        ...LEVEL_STATES[level],
      } as Pick<IState, keyof IState>);
    }
  };

  /**
   * Retrieves the range of week/date values for the given level and year.
   *
   * @param level The time period level.
   * @param value The value for the level.
   * @param year  The selected year (for filtering weeks/dates).
   * @returns The matching record from time period data.
   */
  getWeekRange = (level, value, year) => {
    const {
      filter_data: {
        time_period_filter_data: { data },
      },
    } = this.props;
    if (level !== 'year') {
      return data.find((col) => col[level] === value && col['year'] === year);
    } else {
      return data.find((col) => col[level] === value);
    }
  };

  /**
   * Toggles selection of a time period filter (year, quarter, etc.).
   *
   * @param selected_item The value of the selected time period.
   * @param level The level of time period (year, quarter, month, etc.).
   * @param validations Higher-level filters required for valid selection.
   */
  selectTimePeriod = (selected_item, level, validations) => {
    this.setState((prevState, props) => {
      let { selectedTimePeriodFilters } = prevState;

      const time_period_exists = selectedTimePeriodFilters.some((vl) =>
        validations.every(
          (validation) => vl[validation] === prevState[`active_${validation}`]
        ) && vl[level] === selected_item
      );

      if (time_period_exists) {

        selectedTimePeriodFilters = selectedTimePeriodFilters.filter(
          (val) => val[level] !== selected_item
        );
      } else {
        const newFilters = props.filter_data.time_period_filter_data.data.filter(
          (val) =>
            validations.every(
              (validation) => val[validation] === prevState[`active_${validation}`]
            ) && val[level] === selected_item
        );

        selectedTimePeriodFilters = [...selectedTimePeriodFilters, ...newFilters];
      }

      return {
        selectedTimePeriodFilters,
        is_update_filter: true
      };
    });
  };


  /**
   * Checks whether range keys (minimum/maximum) exist in time period data.
   *
   * @returns {boolean} True if both min/max keys are present.
   */
  isRangeKeysAvailable = () => {
    const {
      filter_data: {
        time_period_filter_data: { data },
      },
    } = this.props;

    return Object.keys(data[0]).filter(key => key.startsWith('minimum_') || key.startsWith('maximum_')).length === 2;
  }

  /**
   * Generates accordion panels for hierarchical time period filters.
   *
   * @param level Current time period level being rendered.
   * @param isRangeAvailable Whether range keys are present.
   * @param levelCount Depth of the current level.
   * @param validations Validation keys for filtering nested levels.
   * @returns {AccordionPanelProps[]} Panels for the accordion.
   */
  getTimePeriodColumnValues = (level, isRangeAvailable, levelCount = 1, validations: any = []) => {
    const timePeriodPanels: Array<AccordionPanelProps> = [];
    const {
      filter_data: {
        time_period_filter_data: { data },
      },
    } = this.props;
    const { selectedTimePeriodFilters, time_period_obj } = this.state;
    if (data[0]) {
      if (data[0][level]) {
        let values: any = this.getTimePeriodValues(data, validations, level);

        let diff = isRangeAvailable ? 2 : 0;

        values.forEach((val) => {
          let range: any = {};

          if (isRangeAvailable && levelCount === Object.keys(time_period_obj).length) {
            range = this.getWeekRange(level, val, this.state.active_year)
          }

          timePeriodPanels.push({
            key: val,
            title: {
              index: val,
              active: this.state[`active_${level}`] === val,
              content: (
                <Checkbox
                  data-testid={"checkbox"}
                  checked={!!selectedTimePeriodFilters.find(value => validations.every(validation => value[validation] === this.state[`active_${validation}`]) && value[level] === val)}
                  label={this.timePeriodLabel(level, val, isRangeAvailable, levelCount, data, range)}
                  onChange={(e) => this.selectTimePeriod(val, level, validations)}
                ></Checkbox>
              ),
              icon: (this.renderIcon(levelCount, data, diff, level, val, time_period_obj)),
              className: 'filter-popup-allign-left no-border',
            },
            content:
              levelCount < Object.keys(time_period_obj).length ? {
                content: (
                  <Accordion.Accordion
                    exclusive={false}
                    panels={this.getTimePeriodColumnValues(
                      TIME_PERIOD_PANEL[level],
                      isRangeAvailable,
                      levelCount + 1,
                      [...validations, level]
                    )}
                  />
                ),
                active: this.state[`active_${level}`] === val,
              } : {}
          });
        });
      } else if (level !== undefined) {
        return this.getTimePeriodColumnValues(TIME_PERIOD_PANEL[level], isRangeAvailable, levelCount, validations)
      } else {
        return
      }
    }

    return timePeriodPanels;
  };

  /**
   * Retrieves distinct values for a given time period level,
   * applying parent validation filters.
   *
   * @param data The time period dataset.
   * @param validations Parent keys to validate against.
   * @param level The time period level (year, quarter, etc.).
   * @returns {string[]} Unique values for the level.
   */
  getTimePeriodValues = (data, validations, level) => {
    return Array.from(
      new Set(data.map((value) => {
        if (validations.length > 0) {
          return validations.every(validation => value[validation] === this.state[`active_${validation}`]) ? value[level] : '';
        } else {
          return value[level];
        }
      }).filter(val => !!val))
    );
  }

  /**
   * Builds the label text for a time period dropdown option.
   *
   * @param level The time period level.
   * @param val The value at the level.
   * @param isRangeAvailable Whether range data is available.
   * @param levelCount Current depth in hierarchy.
   * @param data The full time period dataset.
   * @param range The min/max range object (if available).
   * @returns {string} A formatted label string.
   */
  timePeriodLabel = (level, val, isRangeAvailable, levelCount, data, range) => {
    let label = '';
    if (level === 'quarter') {
      label = `Q${val}`;
    } else if (level === 'date') {

      let date_range = data.find(col => (col['year'] === this.state.active_year && col['month'] === this.state.active_month && col[level] === val))['date_range'];

      label = date_range ? `${val} (${date_range})` : val;

    } else {
      label = level === 'week' ? `W${val}` : (val + '');
    }
    label = label + (isRangeAvailable && range !== undefined && levelCount === Object.keys(this.state.time_period_obj).length ? `(${range['minimum_' + level + '_range']} - ${range['maximum_' + level + '_range']})` : '')
    return label;
  }

  /**
   * Placeholder for retrieving a selected filter column.
   * (Currently not implemented.)
   *
   * @param filter_column The filter column to retrieve.
   */
  getselectedfilter = (filter_column) => {

  }

  /**
   * Renders an expand/collapse icon for nested time period dropdowns.
   *
   * @param levelCount Current depth level.
   * @param data Time period data.
   * @param diff Adjustment for range availability.
   * @param level Current time period level.
   * @param val Current value at the level.
   * @param time_period_obj Time period object containing hierarchy levels.
   * @returns {JSX.Element|string} The icon element or empty string.
   */
  renderIcon = (levelCount, data, diff, level, val, time_period_obj) => {
    if (level === 'date') {
      return '';
    }
    let i_name = this.state[`active_${level}`] === val ? 'minus square outline' : 'plus square outline';
    return levelCount < Object.keys(time_period_obj).length ? <Icon
      className="icon-right"
      data-testid="time_period_expand_icon"
      onClick={() => this.updateTimePeriodLevelState(level, val)}
      color="grey"
      name={i_name as any}
      link
    /> : ''
  }

  /**
   * Renders a batch of dropdowns for filter columns between given indices.
   * Handles both group-by and column filters.
   *
   * @param start_index Starting index in filter_columns.
   * @param end_index Ending index in filter_columns.
   * @returns {JSX.Element[]} Rendered dropdown elements.
   */
  returnDropdowns = (start_index: number, end_index: number) => {
    let { filter_columns } = this.state;
    let { search_filter_obj } = this.props;
    let dropdowns: JSX.Element[] = [];
    for (let i = start_index; i < end_index; i++) {
      if(filter_columns[i].type==="groupby_column"){ 
      let drpdwn_element = (
        <Form.Dropdown
          key={`filter-${i}`}
          label={this.getDropdownLabel(filter_columns[i])}
          search
          selection
          selectOnNavigation={false}
          selectOnBlur={false}
          data-testid="dc_dropdown"
          placeholder="Select Filter"
          name={filter_columns[i].column_id || filter_columns[i].filter_name}
          value={this.getAppliedFilter(filter_columns[i])}
          error={this.isFilterError(filter_columns[i])}
          options={this.setDropdownOptions(filter_columns[i])}
          onChange={this.handleFilterDropdownChange}
        />
      );
      dropdowns.push(drpdwn_element);
      }else{
        const appliedFilter = this.getAppliedFilter(filter_columns[i]);
        let dropdown_element = (
          <Form.Dropdown
            key={`filter-${i}`}
            data-testid="column_dropdown"
            className={this.getAppliedFilter(filter_columns[i])?.length > 0 ? "multiple-dropdown teams-color" : "multiple-dropdown"}
            label={this.getDropdownLabel(filter_columns[i])}
            search
            onSearchChange={(e) => this.getColumnValues(filter_columns[i].column_id, e, filter_columns[i].table_id)}
            selection

            onFocus={(e) => {
              this.setState({ active_col_id: filter_columns[i].column_id })
              if (search_filter_obj[filter_columns[i].column_id] !== undefined) {
                let search_fil_data = {
                  column_id: filter_columns[i].column_id,
                  data: search_filter_obj[filter_columns[i].column_id],
                }
                this.props.setSearchFilterData(search_fil_data)
                this.props.setColumnFilterData(search_fil_data)
              } else {
                this.props.setColumnFilterData({})
                this.props.setSearchFilterData({})
                this.getColumnValues(filter_columns[i].column_id, e, filter_columns[i].table_id, filter_columns[i].filter_name)
              }
            }}
            onBlur={() => {
              if (search_filter_obj[filter_columns[i].column_id] === undefined) {
                search_filter_obj[filter_columns[i].column_id] = this.props.column_filter_data.data
              }
              this.props.updateFiltersObj(search_filter_obj)
              this.props.setColumnFilterData({})
              this.props.setSearchFilterData({})
              this.setState({ column_filter_values: {} })
              clearTimeout(this.timer)
            }}
            selectOnNavigation={false}
            selectOnBlur={false}
            closeOnChange={false}
            placeholder={"Select Filter"}
            name={filter_columns[i].column_id || filter_columns[i].filter_name}
            text={appliedFilter?.length > 0 ? appliedFilter.join() : ['Select Filter']}
            error={this.isFilterError(filter_columns[i])}
            options={this.setMultipleDropdownOptions(filter_columns[i])}
            onMouseDown={(e, data) => this.getselectedfilter(filter_columns[i])}
            onKeyDown={(event: any) =>
              event.key === 'Enter' ? this.updateSelectedItem(event, filter_columns[i].column_id) : null
            }
          />
        );
        dropdowns.push(dropdown_element);
      }
    }
    if ((end_index - start_index) <= 3) {
      let time_period_dropdown = this.returnTimePeriodDropdown();
      if (time_period_dropdown) {
        dropdowns.push(time_period_dropdown);
      }
    }

    return dropdowns;
  };

  /**
   * Fetches available values for a given column based on current filters.
   * Supports delayed search and initial focus fetch.
   *
   * @param column_id The ID of the filter column.
   * @param e The triggering event.
   * @param table_id The ID of the table.
   * @param column_name Optional name of the column.
   */
  getColumnValues = (column_id, e: any, table_id, column_name?: string) => {
    let { template_config, column_filter_data, team_context, va_id } = this.props;
    let { filter_columns } = this.state;
    let applied_filters: any = []
    this.setState({ search_value: e.target.value })
    filter_columns.filter(filter => filter.type === 'column' && Object.keys(filter.applied_filter).length > 0)
      .forEach(filter => {
        filter.applied_filter['values'] = filter.applied_filter['values']?.flat()
        if (filter.column_id !== column_id) {
          applied_filters.push(filter.applied_filter)
        }
      })
    let updated_col_filters = applied_filters.slice(0)
    updated_col_filters = updated_col_filters.filter(filter => filter.values.length > 0)
    updated_col_filters.forEach((filter, i) => {
      if (i !== updated_col_filters.length - 1) {
        filter.conjuction = 'AND'
      } else {
        filter.conjuction = ''
      }
      if (filter.values.length === 0) {
        updated_col_filters.splice(i, 1)
      }
    })
    updated_col_filters.map((filter, i) => {
      if (filter.values.length === 0) {
        updated_col_filters.splice(i, 1)
      }
    })
    if (updated_col_filters.length > 0) {
      updated_col_filters[updated_col_filters.length - 1].conjuction = ""
      if (updated_col_filters[updated_col_filters.length - 1].values.length === 0) {
        updated_col_filters.splice(updated_col_filters.length - 1, 1)
      }
    }
    let dta = {
      table_id: table_id,
      type: template_config.type,
      column_id: column_id,
      column_name: column_name,
      connection_id: template_config.connection_id,
      dataset_id: template_config.dataset_id,
      excel_database_id: template_config.excel_database_id,
      search_string: e.target.value ? e.target.value : "",
      filter: updated_col_filters,
      impersonate_user: template_config.impersonate_user,
      base_filter: this.state.base_filter,
      user_filters: template_config.user_filters,
      va_id: va_id,
      ...team_context
    }
    if (e.type === 'change' && column_filter_data?.data?.length === this.props.filter_data.distinct_data_limit) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => this.props.getMultipleDropdownOptions(dta, this.props.token, "change"), 500);
    } else if (e.type === 'focus') {
      this.props.getMultipleDropdownOptions(dta, this.props.token, "focus")
    }
  }

  /**
   * Updates filter selections when Enter is pressed in a multi-select dropdown.
   *
   * @param event Keyboard event.
   * @param col_id The column ID for the filter.
   */
  updateSelectedItem = (event, col_id) => {
    let { search_value, filter_obj, column_filter_values } = this.state;
    if (String(search_value).trim() !== '') {
      const reg_ex = new RegExp(
        _.escapeRegExp(String(search_value).trim()),
        'i'
      );
      let filtered_values = column_filter_values.data.filter((c_value) => {
        return reg_ex.test(c_value);
      });
      if (filter_obj !== undefined && filter_obj[col_id] !== undefined) {
        filter_obj[col_id] = [...filter_obj[col_id], ...filtered_values]
        let data = { name: col_id, value: filter_obj[col_id] }
        this.handleFilterDropdownChange(event, data)
        this.setState({ filter_obj })
      }
      if (!_.isEqual(filtered_values, this.state.filtered_values))
        this.setState({ filtered_values: filtered_values });
    }
  };


  /**
   * Renders the dropdown field for time period filters (year/quarter/etc.).
   *
   * @returns {JSX.Element|null} A form field containing time period filters, or null.
   */
  returnTimePeriodDropdown = () => {
    const { filter_data } = this.props;
    if (filter_data.time_period_filter_data && Object.keys(filter_data.time_period_filter_data).length > 0) {
      return <Form.Field
        key='time-period'
      >
        <label>{filter_data.time_period_filter_data.property.name}</label>
        <Dropdown search
          className='selection'
          selectOnNavigation={false}
          selectOnBlur={false}
          placeholder="Select Filter" >

          <Dropdown.Menu>
            <Accordion
              exclusive={false}
              className="column-list-accordian"
              fluid
              styled
              panels={this.getTimePeriodColumnValues('year', this.isRangeKeysAvailable())}
              style={{ overflowX: 'auto' }}
            ></Accordion>
          </Dropdown.Menu>
        </Dropdown>
      </Form.Field>
    } else {
      return null;
    }
  }

  /**
   * Checks if a filter column has validation errors.
   *
   * @param filter_column The filter column to check.
   * @returns {boolean} True if the filter column is invalid.
   */
  isFilterError = (filter_column: FilterInfo) => {
    let { is_submit_filter } = this.state;
    let is_error = false;
    if (filter_column.type === CONFIG.GROUPBYCOLUMN) {
      is_error = is_submit_filter && !filter_column.applied_filter.column_id;
    }
    return is_error;
  };

  /**
   * Builds the label element for a filter column dropdown,
   * including tooltip and "Clear" action if applicable.
   *
   * @param filter_column The filter column to label.
   * @returns {JSX.Element} The rendered label.
   */
  getDropdownLabel = (filter_column: FilterInfo) => {
    let filter_label = filter_column.display_name
      ? filter_column.display_name
      : filter_column.filter_name;
    let filter_unique_id = `${filter_label}${filter_column.type}`;
    return (
      <div
        className="filter-label-header"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Popup
          className="filter-label-tooltip"
          position="bottom center"
          on="click"
          hideOnScroll
          basic
          content={filter_label}
          open={this.state.show_filter_label_tooltip === filter_unique_id}
          trigger={
            <button

              className="label-name"
              onMouseOver={(e) => this.isPopUpEnabled(e, filter_unique_id)}
              onFocus={(e) => this.isPopUpEnabled(e, filter_unique_id)}
              onMouseLeave={this.disablePopup}
            >
              {' '}
              {filter_label}
            </button>
          }
        />
        <small>
          <button
            className="clear-filter"
            onClick={() => {
              this.clearIndivisualFilter(filter_column);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                this.clearIndivisualFilter(filter_column);
              }
            }}
          >
            {filter_column.type !== 'groupby_column' &&
              Object.keys(filter_column.applied_filter).length !== 0
              ? 'Clear'
              : ''}
          </button>
        </small>
      </div>
    );
  };

  /**
   * Enables popup tooltip for overflowing filter labels.
   *
   * @param event The mouse/keyboard event.
   * @param element Unique ID of the label element.
   */
  isPopUpEnabled = (event, element: string) => {
    let target_elem = event.target;
    let elem_width = target_elem.getBoundingClientRect().width;
    if (Math.ceil(elem_width) < target_elem.scrollWidth) {
      this.setState({ show_filter_label_tooltip: element });
    }
  };

  /**
   * Disables the currently active filter label tooltip.
   */
  disablePopup = () => {
    if (this.state.show_filter_label_tooltip !== '') {
      this.setState({ show_filter_label_tooltip: '' });
    }
  };
  
  /**
   * Retrieves the applied filter values for a column.
   *
   * @param filter_column The filter column.
   * @returns {any[]} Array of applied filter values.
   */
  getAppliedFilter = (filter_column: FilterInfo) => {
    let applied_filter;
    if (filter_column.type === CONFIG.GROUPBYCOLUMN) {
      applied_filter = filter_column.applied_filter.column_id
        ? filter_column.applied_filter.column_id
        : '';
    } else if (filter_column.applied_filter['values']) {
      const firstValue = filter_column.applied_filter['values'][0];

      if (typeof firstValue === "object" && firstValue !== null) {
        applied_filter = firstValue || ["Null"];
      } else if (firstValue === null) {
        applied_filter = filter_column.applied_filter['values']?.filter((_, i) => i > 0);
      } else if (typeof firstValue === "string" || typeof firstValue === "number") {
        applied_filter = filter_column.applied_filter['values'];
      }else{
        applied_filter = []
      }
    }else{
      applied_filter = []
    }

    if (applied_filter?.length === 1 && applied_filter[0] === null) {
      applied_filter = []
    }
    return applied_filter
  };

  /**
   * Retrieves filtered dataset values for a given filter column.
   * Applies dependent filter constraints if applicable.
   *
   * @param filter_column The filter column definition.
   * @param column_index The index of the column in filter data.
   * @param is_filterd Whether dependent filters are applied.
   * @returns {string[]} Sorted unique values for the column.
   */
  getFilteredData = (
    filter_column: FilterInfo,
    column_index: number,
    is_filterd: boolean
  ) => {

    let { filter_data, parent_mapping_graph } = this.state;
    let filterd_data_acc_dependent_filter: string[][] = [];
    let data: string[] = [];
    if (filter_column.column_id) {
      let reachble_nodes = parent_mapping_graph.findReachableNodes([
        filter_column.column_id,
      ]);
      if (reachble_nodes[filter_column.column_id]) {
        reachble_nodes[filter_column.column_id].forEach((col_id) => {
          let filter_result = this.filterData(
            col_id,
            filterd_data_acc_dependent_filter,
            filter_data.data,
            is_filterd
          );
          filterd_data_acc_dependent_filter =
            filter_result.filterd_data_acc_dependent_filter;
          is_filterd = filter_result.is_filterd;
        });
      }
    }
    if (Object.keys(filter_data.parent_mapping).length > 0) {
      data = is_filterd
        ? filterd_data_acc_dependent_filter.map((d) => {
          return d[column_index];
        })
        : filter_data.data.map((d) => {
          return d[column_index];
        });
    } else {
      data = is_filterd
        ? filterd_data_acc_dependent_filter.map((d) => {
          return d[column_index];
        })
        : filter_data.data[column_index]
    }

    data = Array.from(new Set(data));
    return data.sort((a: any, b: any) => a - b);
  };

  /**
   * Filters data based on dependent filter selections.
   *
   * @param col_id The dependent column ID.
   * @param filterd_data_acc_dependent_filter The accumulated filtered data.
   * @param filter_data_data The full filter dataset.
   * @param is_filterd Whether filtering is already applied.
   * @returns Updated filtered data and filtering state.
   */
  filterData = (
    col_id: number,
    filterd_data_acc_dependent_filter: string[][],
    filter_data_data: string[][],
    is_filterd: boolean
  ) => {
    let { filter_data, filter_columns } = this.state;
    let dependent_filter_array = [filterd_data_acc_dependent_filter];
    let dependent_column_index = filter_data.columns.findIndex(
      (co) => co.id === col_id
    );
    let filter_index = filter_columns.findIndex((f) => f.column_id === col_id);
    if (
      filter_index !== -1 &&
      dependent_column_index !== -1 &&
      filter_columns[filter_index].applied_filter['values']
    ) {
      let dependent_filterd_value =
        typeof filter_columns[filter_index].applied_filter['values'][0] === "object" ? filter_columns[filter_index].applied_filter['values'][0] : filter_columns[filter_index].applied_filter['values'];
      dependent_filterd_value.map(filter_value => {
        filterd_data_acc_dependent_filter = is_filterd
          ? filterd_data_acc_dependent_filter.filter(
            (d) => d[dependent_column_index] === filter_value
          )
          : filter_data_data.filter(
            (d) => d[dependent_column_index] === filter_value
          );
        dependent_filter_array.push(filterd_data_acc_dependent_filter)
      })
      is_filterd = true;
    }
    filterd_data_acc_dependent_filter = dependent_filter_array.flat()
    return { filterd_data_acc_dependent_filter, is_filterd };
  };

  /**
   * Returns IDs of selected group-by filter columns (excluding the given one).
   *
   * @param filter_column The filter column being considered.
   * @returns {number[]} Array of selected group-by column IDs.
   */
  getSelectedColumn = (filter_column: FilterInfo) => {
    let selected_column: number[] = [];
    this.state.filter_columns.forEach((co) => {
      if (
        filter_column.filter_name !== co.filter_name &&
        co.type === CONFIG.GROUPBYCOLUMN &&
        co.applied_filter.column_id
      ) {
        selected_column.push(co.applied_filter.column_id);
      }
    });
    return selected_column;
  };

  /**
   * Sorts group-by filter column options alphabetically by display name.
   *
   * @param filter_column_options Array of group-by column options.
   * @returns {GroupByColumnOption[]} Sorted options.
   */
  sortFilterColumns = (filter_column_options: GroupByColumnOption[]) => {
    filter_column_options.slice().sort((f_col, s_col) => {
      let f_name = f_col.display_name ? f_col.display_name : f_col.column_name;
      let s_name = s_col.display_name ? s_col.display_name : s_col.column_name;
      return f_name.localeCompare(s_name);
    });
    return filter_column_options;
  };

  /**
   * Generates dropdown options for a filter column.
   *
   * @param filter_column The filter column.
   * @returns {DropdownItemProps[]} Dropdown options.
   */
  setDropdownOptions = (filter_column: FilterInfo) => {
    let { filter_data } = this.props;
    let options: DropdownItemProps[] = [];
    if (!filter_column.column_id && filter_column.options) {
      let selected_column: number[] = this.getSelectedColumn(filter_column);
      let column_options = this.sortFilterColumns(
        filter_column.options.slice()
      );
      column_options.forEach((op) => {
        if (!selected_column.includes(op.column_id)) {
          options.push({
            key: op.column_id,
            text: op.display_name ? op.display_name : op.column_name,
            value: op.column_id,
            // disabled: (op.display_name ? op.display_name : op.column_name)===this.state.heaing_2_bind_col_name
          });
        }
        options = options.filter(op => op.text !== this.state.heaing_2_bind_col_name)
      });
    } else {
      let column_index = filter_data.columns.findIndex(
        (co) => co.id === filter_column.column_id
      );
      if (column_index !== -1) {
        let data = this.getFilteredData(filter_column, column_index, false);
        options = data.map((op, i) => {
          return {
            key: i,
            text: op,
            value: op || "Null",
          };
        });
      }
    }
    return options;
  };

  /**
   * Generates options for multi-select dropdowns with labels and checkboxes.
   *
   * @param filter_column The filter column.
   * @returns {DropdownItemProps[]|any[]} Array of dropdown items or loader/warning elements.
   */
  setMultipleDropdownOptions = (filter_column: FilterInfo) => {
    let { filter_data, column_filter_data, search_filter_data, search_filter_obj } = this.props;
    let { filter_obj, show_filter_label_tooltip, column_filter_values, active_col_id } = this.state;
    let options: DropdownItemProps[] = [];
    let is_loader = true;
    if (search_filter_data || column_filter_data) {
      if (search_filter_data.column_id && search_filter_data.column_id === active_col_id) {
        is_loader = false;
      }
    }
    if (!filter_column.column_id && filter_column.options) {
      let selected_column: number[] = this.getSelectedColumn(filter_column);
      let column_options = this.sortFilterColumns(
        filter_column.options.slice()
      );
      column_options.forEach((op) => {
        if (!selected_column.includes(op.column_id)) {
          options.push({
            key: op.column_id,
            text: op.display_name ? op.display_name : op.column_name,
            value: op.column_id,
            // disabled: (op.display_name ? op.display_name : op.column_name)===this.state.heaing_2_bind_col_name
          });

        }
        options = options.filter(op => op.text !== this.state.heaing_2_bind_col_name)
      });
    } else {
      let column_index = filter_data.columns.findIndex(
        (co) => co.id === filter_column.column_id
      );
      if (column_index !== -1) {
        let filter_search_values: any = [];
        if (column_filter_values && column_filter_values?.data?.length > 0) {
          filter_search_values = [...column_filter_values.data, ...this.getAppliedFilter(filter_column)]
        }

        let uniqueItems = filter_search_values.filter((value, index) => filter_search_values.indexOf(value) === index)
        let data = column_filter_values ? uniqueItems : [];
        options = data?.map((op, i) => {
          return {
            key: i,
            text: op,
            value: op || "Null",
            onClick: (event, data) => {
              this.selectvalue(event, filter_column, op)

            },
            content: (
              <Popup
                trigger={
                  <Label
                    id="touch-event"
                    content={<div className='multiple-dropdown-options add-ellipsis-to-text'>{op}</div>}
                    onMouseOver={(e) =>
                      this.isPopUpEnabled(e, op)
                    }
                    onTouchEnd={this.disablePopup}
                    onScroll={this.disablePopup}
                    onWheel={this.disablePopup}
                    onMouseLeave={this.disablePopup}
                    className="dropdowm-item-label add-ellipsis-to-text double-space"

                    icon={
                      (filter_obj[`${filter_column.column_id}`])?.includes(op)
                        ? 'check square outline'
                        : 'square outline'
                    }
                  />
                }
                className='double-space'
                closeOnDocumentClick
                closeOnTriggerClick
                closeOnTriggerMouseLeave
                hideOnScroll
                content={op}
                open={show_filter_label_tooltip !== null && show_filter_label_tooltip !== '' && show_filter_label_tooltip === op}
              />
            ),
          };
        });
        if (options.length > 0) {
          options.unshift({
            selected: true,
            key: "Select all",
            text: "Select all", value: "Select all",
            onClick: (event) => this.selectAllValues(event, data, filter_column),
            content: (
              <Label
                content={"Select all"}
                className="select-all dropdowm-item-label add-ellipsis-to-text"
                icon={(filter_obj[`${filter_column.column_id}`])?.length === data.length
                  ? <>
                    {/* <Icon name='check square outline' /> */}
                    <Icon.Group >
                      <Icon name='check square outline' />

                    </Icon.Group>
                  </> : <Icon name='square outline' />
                }
              />
            )
          });
        } else if (search_filter_obj[active_col_id] === undefined && is_loader) {
          let loader = (<Loader active inline="centered" />)
          options.push(loader)
        }
      }
    }
    if (options.length >= this.props.filter_data.distinct_data_limit + 1 && active_col_id === column_filter_values.column_id) {
      let warn = (<Label attached='bottom' id='warn-label' basic style={{ backgroundColor: 'white' }}><Icon name='warning sign' />Search for missing items</Label>)

      options.push(warn)
      return options
    } else {
      return options;
    }
  };

  /**
   * Selects or deselects all filter values in a dropdown.
   *
   * @param event The triggering event.
   * @param data Available options for the column.
   * @param filter_column The filter column being updated.
   */
  selectAllValues = (event, data, filter_column) => {
    let { filter_obj, is_update_filter } = this.state;
    filter_obj[`${filter_column.column_id}`] = filter_obj[`${filter_column.column_id}`].length < data.length ? data : []
    if (!is_update_filter) {
      this.setState({ is_update_filter: true })
    }
    this.setState(filter_obj)
    let updated_data = { name: filter_column.column_id, value: filter_obj[`${filter_column.column_id}`] }
    this.handleFilterDropdownChange(event, updated_data)
  }

  /**
   * Toggles selection of an individual filter value.
   *
   * @param event The triggering event.
   * @param col The filter column.
   * @param selected_item The selected value.
   */
  selectvalue = (event, col, selected_item) => {
    let { filtered_values, is_update_filter, filter_obj } = this.state;
    let { search_filter_obj } = this.props;
    if (!is_update_filter) {
      is_update_filter = true;
    }
    if (filter_obj[col.column_id]?.includes(selected_item)) {

      let item_index = filter_obj[col.column_id].indexOf(selected_item);
      filter_obj[col.column_id].splice(item_index, 1);
      this.setState({ filtered_values, is_update_filter, filter_obj });
      let data = { name: col.column_id, value: filter_obj[col.column_id] }
      this.handleFilterDropdownChange(event, data)
    } else {
      filter_obj[col.column_id] = [...filter_obj[col.column_id], selected_item]
      this.setState(filter_obj)
      let data = { name: col.column_id, value: [...filter_obj[col.column_id], selected_item] }
      this.handleFilterDropdownChange(event, data)
    }
    for (let col_id in search_filter_obj) {
      if (col_id !== col.column_id) {
        delete search_filter_obj[col_id]
      }
    }
    this.props.updateFiltersObj(search_filter_obj)
  }


/**
 * Renders the FilterPopup component UI.
 * Displays the filter dropdowns and action buttons if there are filter columns
 * or time period filter data available. Otherwise, it shows a loading component.
 * The action buttons allow clearing all filters or submitting the selected filters.
 * The submit button is disabled if there are no updates to the filters.
 */

  render() {
    let { filter_columns, is_update_filter } = this.state;
    let { filter_data } = this.props;
    return ((Object.keys(filter_columns).length > 0) || (Object.keys(filter_data.time_period_filter_data).length > 0)) ?
      (
        <>
          <Form id="filter-form">{this.renderFilterDropdowns()}</Form>
          <Menu secondary attached="bottom">
            <Menu.Menu position="right">
              <Button
                basic
                primary
                content={CONFIG.BUTTONTEXT.CLEARALL}
                onClick={() => this.clearFilters()}
              />
              <Button
                primary
                content={CONFIG.BUTTONTEXT.SUBMIT}
                disabled={!is_update_filter}
                onClick={() => this.submitFilters()}
              />
            </Menu.Menu>
          </Menu>
        </>
      )
      : <LoaderComponent active_loader={true} loading_time={0} />
  }
}

/**
 * Maps state to props for the FilterPopup component.
 * Retrieves the column filter data, search filter data, and search filter object from the card library state.
 * @param {Object} state - The state of the application.
 * @returns {Object} A props object containing the column filter data, search filter data, and search filter object.
 */
const mapStateToProps = (state: any) => {
  const { column_filter_data, search_filter_data, search_filter_obj } = state.cardLibraryState;
  return ({
    column_filter_data,
    search_filter_data,
    search_filter_obj,
  });
};

export default connect(mapStateToProps, { getMultipleDropdownOptions, setColumnFilterData, setSearchFilterData, updateFiltersObj })(FilterPopup);
